import type { Snack } from '@shared/interfaces/snack'
import type { User } from '@shared/interfaces/user'
import FetchApiWrapperService from '@shared/services/fetch-api-wrapper'

class EdgeFunctionsWrapperService {
  constructor() {}

  public exchangeStravaToken(code: string, scope: string): Promise<User> {
    const endpoint = '/api/edge-functions/exchange-strava-token'
    const request = { code, scope }
    return FetchApiWrapperService.post<User, { code: string; scope: string }>(endpoint, request)
  }

  public saveSelectedSnacks(userId: string, token: string, snackPack: Snack[]): Promise<void> {
    const endpoint = '/api/edge-functions/customize-snacks'
    const request = { userId, token, snackPack: snackPack }
    return FetchApiWrapperService.post<void, { userId: string; token: string; snackPack: Snack[] }>(
      endpoint,
      request
    )
  }

  public getSnacks(userId: string, token: string): Promise<Snack[]> {
    const endpoint = '/api/edge-functions/customize-snacks'
    const params: Record<string, string> = { userId: userId, token: token }

    const fullEndpoint = `${endpoint}?${new URLSearchParams(params).toString()}`

    return FetchApiWrapperService.get<Snack[]>(fullEndpoint, token)
  }
}
export default new EdgeFunctionsWrapperService()
